<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <img src="../../../assets/wuxue.png" alt="Login logo" class="loginLogo" />
    <div class="hosName">武穴市第一人民医院</div>
    <div class="ourterTitle">影像检查数字化报告/影像系统</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value43800001.name43800001"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value43800001.value1"
          placeholder="请输入影像号或住院号或就诊卡号"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      value43800001: {
        name43800001: "",
        value1: "",
      },
      rules: true,
    };
  },
  methods: {
    inputFn() {
      if (this.value43800001.name43800001 != "" && this.value43800001.value1 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value43800001", JSON.stringify(this.value43800001));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name43800001")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .hosName {
    font-size: 20px;
    padding: 10px 0;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
